//@state
export interface azmoonState {
  azmoon:boolean,
  question_page_number:Number
}

export const initialState: azmoonState = {
  azmoon:true,
  question_page_number:1
}
